<template>
  <basic-dialog v-model="dialog"
                :actionButtons="actionButtons"
                :loading="saving"
                :title="$t('surveys.estimated_answerers')">

    <v-card-text class="scroll-content">
      <v-form ref="form">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="survey.estimatedAnswerers"
              :dense="$vuetify.breakpoint.xsOnly"
              :label="$t('amount')"
              :placeholder="$t('surveys.amount_example_placeholder')"
              :rules="[$rules.positiveNumbersOnly]"
              autocomplete="off"
              class="mt-5"
              min="0"
              outlined
              persistent-placeholder
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog";
import surveyApi from "@/api/survey";

export default {
  name: "EditEstimatedAnswerersDialog",
  components: {BasicDialog},
  data() {
    return {
      saving: false,
      dialog: false,
      survey: {},
      actionButtons: {
        cancel: {
          click: this.close,
        },
        save: {
          click: this.save,
        }
      },
    }
  },
  methods: {
    open(survey) {
      this.dialog = true;
      this.survey = {...survey};
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;

      const survey = {...this.survey};

      try {
        const response = await surveyApi.updateSurvey(survey);
        this.$emit('survey-saved', response);
        this.dialog = false;
        this.$showSuccessNotification(this.$t('surveys.survey_saved'));
      } catch (error) {
        this.$handleApiError(error, this.$t('surveys.errors.save_error'));
      }
      this.saving = false;
    },
    close() {
      this.dialog = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.scroll-content {
  max-height: calc(100vh - 240px);
  overflow: auto;
}

@media screen and (min-width: 600px) {
  .scroll-content {
    max-height: calc(100vh - 300px);
    overflow: auto;
  }
}
</style>
